import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AttachmentService } from 'src/app/service/attachment.service';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { MeetingService } from 'src/app/service/meeting.service';
import { PermissionService } from 'src/app/service/permission.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { UtilityService } from 'src/app/service/utility.service';
import { AddLinkDialogComponent } from '../add-link-dialog/add-link-dialog.component';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
declare var CKEDITOR: any;
import { environment_const, meetingTourValues, scheduleMeetingTourValues } from 'src/environments/environment';
import { MinutesCollabDetails } from 'src/app/models/basicMeetingModel';
import { UtcDatePipe } from 'src/app/pipe/UtcDate.pipe';
import { HistoryComponent } from '../history/history.component';
import { HistoryDialogService } from 'src/app/service/history-dialog.service';
import { CK5_EDITOR, CK5_TOOLBAR, CK5_READONLY_CONFIG, buildCk5Config, setupCk5UploadAdapter as setupCommonCk5UploadAdapter } from 'src/app/config/ck5-common';
import Quill from 'quill';
import { buildQuillModules, setupQuillUploadAdapter } from 'src/app/config/quill-common';
import { quillSharedToolbar } from 'src/app/config/quill-shared-toolbar';
import { AgoraConfigService } from 'src/AgoraConfigService';

@Component({
  selector: 'app-instant-meeting-decision',
  templateUrl: './instant-meeting-decision.component.html',
  styleUrls: ['./instant-meeting-decision.component.css'],
  providers:[UtcDatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstantMeetingDecisionComponent implements OnInit,AfterViewInit {
  //UI Team variable declaration
  collabVariable = 'active'
disaleAttachmentFileIcon: any;
  @Input()hideParts: any
  //padlock variable
  padlock :any;
  matDialogRef!: MatDialogRef<AttachmentDialogComponent>;
  isPrivate: any;
  showToolTip = false;
  agendaAttachResp: any;
  attachCount: boolean =true;
  attachmentCount: any;
  attachmentTotalCnt: any = true;
  attachmentIcon = 'Y';
  @Input() pinDialogTriggered = false;
  @Input() contentEditableBoolmin = false;
  editCollabData = <MinutesCollabDetails>{};
  @Input() meetingResponse:any
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
    );
    isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.Medium
    )
    isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.Small
    )
    @Input()videoSectionStatusChecker : any
  disableDecisionIcon: any;

  //property for adding new class for login user is a task user.
  selectedTabName: any;
  padlockDisable:any;
  private quillInst?: Quill;
  private isActiveEditor: boolean = false;
  private hasUserInteracted: boolean = false;

  constructor(private utility:UtilityService,private permissionService:PermissionService,public sideNavService : SideNavServiceService, private readonly breakpointObserver: BreakpointObserver,public meetingService:MeetingService,private dialog: MatDialog, public commonMinService:FreeFormMinutesService,public freeFormAgenda:FreeFormAgendaService,public attachService:AttachmentService,private historyDialogService:HistoryDialogService, private agoraConfig: AgoraConfigService) {
   }

  // ===== Quill integration (shared toolbar) =====
  onQuillEditorReady(quill: Quill) {
    try {
      this.quillInst = quill;
      // Register with shared toolbar manager
      try {
        const selectorId = (this as any).editorConfig?.sharedToolbar?.selectorId || 'quill-shared-toolbar';
        quillSharedToolbar.registerEditor(quill, selectorId);
      } catch {}

      const rootEl = quill.root as HTMLElement;
      const decisionIdVal = this.minAttrList.decisionId;

      // Ensure legacy attributes on the editable element (services rely on these)
      const ensureLegacyAttrs = () => {
        try {
          rootEl.id = 'agMinId' + decisionIdVal;
          rootEl.classList.add('agChildDecision','minComCls');
          rootEl.setAttribute('minId', String(decisionIdVal));
          rootEl.setAttribute('minid', String(decisionIdVal));
          rootEl.setAttribute('decisionId', String(decisionIdVal));
          rootEl.setAttribute('agId', String(this.minAttrList.agendaId));
          rootEl.setAttribute('agid', String(this.minAttrList.agendaId));
          rootEl.setAttribute('entityType', this.minAttrList?.entityType || 'MD');
        } catch {}
      };
      ensureLegacyAttrs();

      // Guard blur-save while clicking toolbar
      const selectorId = (this as any).editorConfig?.sharedToolbar?.selectorId || 'quill-shared-toolbar';
      const shared = document.querySelector('#' + selectorId) as HTMLElement | null;
      if (shared) {
        shared.style.display = 'block';
        shared.addEventListener('mousedown', () => { this.toolbarInteracting = true; }, true);
        shared.addEventListener('mouseup', () => { setTimeout(() => this.toolbarInteracting = false, 0); }, true);
        shared.addEventListener('click', () => { setTimeout(() => this.toolbarInteracting = false, 0); }, true);
      }

      // Outside click handler: save when clicking outside editor AND toolbar (only after user interaction)
      let outsideClickHandler: ((ev: MouseEvent) => void) | null = null;
      outsideClickHandler = (ev: MouseEvent) => {
        // Only handle for this instance when it is currently active AND user has interacted
        if (!this.isActiveEditor || !this.hasUserInteracted) return;
        
        const t = ev.target as Node;
        const insideEditor = rootEl.contains(t);
        const insideToolbar = shared ? shared.contains(t) : false;
        
        // Check if clicking another editor
        const targetEl = ev.target as HTMLElement;
        const clickedAnotherEditor = targetEl?.closest?.('.ql-editor') && !insideEditor;
        
        if (!insideEditor && !insideToolbar) {
          // Deactivate this editor and save
          this.isActiveEditor = false;
          this.onQuillBlur();
        }
      };
      document.addEventListener('mousedown', outsideClickHandler, true);

      // Map mouseup to legacy selection/highlight
      rootEl.addEventListener('mouseup', () => {
        const decisionDiv = document.createElement('div');
        decisionDiv.setAttribute('decisionId', this.minAttrList.decisionId);
        this.handleMouseUp(decisionDiv as unknown as HTMLDivElement);
      });

      // Click -> bring pointer + reinforce attrs + mark as interacted
      rootEl.addEventListener('click', () => {
        try { this.sideNavService.bringPointer(this.minAttrList.decisionId); } catch {}
        ensureLegacyAttrs();
        this.isActiveEditor = true;
        this.hasUserInteracted = true;
      });

      // Mark this instance active on direct interactions (mousedown/focusin)
      rootEl.addEventListener('mousedown', () => { 
        this.isActiveEditor = true; 
        this.hasUserInteracted = true; 
      }, true);
      
      rootEl.addEventListener('focusin', () => { 
        this.isActiveEditor = true; 
        this.hasUserInteracted = true; 
      }, true);

      // Keyboard helpers (same parity as notes)
      const invokeTrackChanges = (keyCode: number) => {
        ensureLegacyAttrs();
        const editableEl = rootEl;
        const syntheticEvent: any = {
          target: editableEl,
          currentTarget: editableEl,
          altKey: true,
          keyCode,
          preventDefault: () => {},
          stopPropagation: () => {},
        };
        this.freeFormAgenda.trackChangesWhileEditing(
          this.minAttrList.decisionId,
          this.minAttrList.agendaId,
          syntheticEvent,
          this.minAttrList.entityType,
          'agMinId' + this.minAttrList.decisionId
        );
      };

      const invokeAgendaEvent = (code: string) => {
        ensureLegacyAttrs();
        const editableEl = rootEl;
        const syntheticEvent: any = {
          target: editableEl,
          currentTarget: editableEl,
          preventDefault: () => {},
          cancel: () => {}
        };
        this.freeFormAgenda.trackAgendaEventOnClick(syntheticEvent, code);
      };

      // Keydown parity with CKEditor: stream generic typing + Alt shortcuts + slash tokens
      rootEl.addEventListener('keydown', (ev: KeyboardEvent) => {
        if (!this.hasUserInteracted) this.hasUserInteracted = true;
        const keyCode = (ev as any).keyCode || ev.which;

        // Generic typing: push to Kafka like notes (exclude Alt shortcuts and Enter slash-handling)
        const isAltShortcut = ev.altKey && (
          keyCode === 78 || // N
          keyCode === 68 || // D
          keyCode === 84 || // T
          keyCode === 49 || keyCode === 97 || // 1
          keyCode === 50 || keyCode === 98 || // 2
          keyCode === 51 || keyCode === 99 || // 3
          keyCode === 71 // G
        );
        if (!isAltShortcut && keyCode !== 13) {
          try {
            ensureLegacyAttrs();
            this.freeFormAgenda.trackChangesWhileEditing(
              this.minAttrList.decisionId,
              this.minAttrList.agendaId,
              ev as any,
              this.minAttrList.entityType,
              'agMinId' + this.minAttrList.decisionId
            );
          } catch {}
        }

        // Alt+N/D/T: create from selected text
        const isAltN = ev.altKey && keyCode === 78;
        const isAltD = ev.altKey && keyCode === 68;
        const isAltT = ev.altKey && keyCode === 84;
        if (isAltN || isAltD || isAltT) {
          invokeTrackChanges(keyCode);
          ev.preventDefault(); ev.stopPropagation();
          return;
        }

        // Alt+1/2/3: convert minute to Note/Decision/Task
        const isAlt1 = ev.altKey && (keyCode === 49 || keyCode === 97);
        const isAlt2 = ev.altKey && (keyCode === 50 || keyCode === 98);
        const isAlt3 = ev.altKey && (keyCode === 51 || keyCode === 99);
        if (isAlt1 || isAlt2 || isAlt3) {
          invokeTrackChanges(keyCode);
          ev.preventDefault(); ev.stopPropagation();
          return;
        }

        // Alt+G: new Agenda
        const isAltG = ev.altKey && keyCode === 71;
        if (isAltG) {
          invokeAgendaEvent('AG');
          ev.preventDefault(); ev.stopPropagation();
          return;
        }

        // Enter: handle trailing slash tokens: delete token, delegate to legacy service, then blur-save
        if (keyCode === 13) {
          try {
            const sel = quill.getSelection();
            if (!sel) return;
            const caret = sel.index;
            const MAX = 48;
            const start = Math.max(0, caret - MAX);
            // Window and ignore trailing whitespace visually after caret
            let seg = quill.getText(start, caret - start);
            const trailing = seg.match(/[\s\u00a0]+$/);
            const strip = trailing ? trailing[0].length : 0;
            const effEnd = caret - strip;
            const effLen = effEnd - start;
            if (effLen <= 0) return;
            seg = quill.getText(start, effLen);

            // Find last '/' and build token letters only
            const slash = seg.lastIndexOf('/');
            if (slash < 0) return;
            let token = '/';
            for (let i = slash + 1; i < seg.length && token.length <= 5; i++) {
              const ch = seg[i];
              if (!/[a-z]/i.test(ch)) break;
              token += ch;
            }
            const valid = /^(\/nn|\/dd|\/tt|\/ag|\/sg|\/agl|\/sgl|\/ddl|\/ttl|\/nnl|\/date|\/dur)$/i;
            if (!valid.test(token)) return;

            // Delete only the token from Quill content
            const tokenLen = token.length + strip; // include trailing spaces previously considered
            quill.deleteText(effEnd - token.length, tokenLen, 'user');

            // Delegate to legacy handler which will insert proper structures
            ensureLegacyAttrs();
            const t = token.toLowerCase();
            if (t === '/ag') {
              try { rootEl.removeAttribute('parentAgId'); } catch {}
            } else if (t === '/sg') {
              try { rootEl.setAttribute('parentAgId', String(this.minAttrList.agendaId)); } catch {}
            }

            const syntheticEvent: any = {
              target: rootEl,
              currentTarget: rootEl,
              preventDefault: () => {},
              cancel: () => {}
            };
            this.freeFormAgenda.trackAgendaEventOnClick(syntheticEvent, t);

            // Mark interacted and force immediate and delayed blur-saves for reliability
            try { this.hasUserInteracted = true; } catch {}
            try { setTimeout(() => this.onQuillBlur(), 50); } catch {}
            try { setTimeout(() => this.onQuillBlur(), 300); } catch {}

            ev.preventDefault(); ev.stopPropagation();
            return;
          } catch {}
        }
      });

      // Wire image upload adapter like CK5
      try {
        const cfg = this.agoraConfig.getConfig();
        setupQuillUploadAdapter(
          quill,
          cfg.apiBaseUrl,
          cfg.endpoints.attachment,
          this.freeFormAgenda.meetingResponse?.meetingId,
          this.minAttrList.agendaId,
          (_url: string) => { try { setTimeout(() => this.onQuillBlur(), 0); } catch {} }
        );
      } catch {}
    } catch {}
  }

  onQuillSelectionChanged(e: any) {
    // DO NOT use selection-change for blur - it fires on load and causes unwanted saves
    // Blur is handled by outside click handler only
  }

  onQuillFocus() {
    try { 
      this.isActiveEditor = true; 
      this.hasUserInteracted = true; 
      this.showToolTip = true; 
    } catch {}
  }

  onQuillBlur() {
    try {
      // Only save if user has actually interacted with this editor
      if (!this.hasUserInteracted) return;
      
      // Guard against toolbar interactions
      if (this.toolbarInteracting) return;
      
      const decisionIdVal = this.minAttrList.decisionId;
      const host = document.getElementById('agMinId' + decisionIdVal) as HTMLElement | null;
      const html = host ? host.innerHTML : (this.minAttrList?.decisionDescription || this.minAttrList?.noteDescription || '');
      // Update local model so subsequent re-inits show latest content immediately
      try {
        // Prefer a decisionDescription field if present; fall back to noteDescription legacy key
        if (typeof this.minAttrList === 'object') {
          if ('decisionDescription' in this.minAttrList) {
            (this.minAttrList as any).decisionDescription = html || '';
          } else {
            (this.minAttrList as any).noteDescription = html || '';
          }
        }
        // Also update meetingResponse tree (agenda -> minutes -> this decision)
        const agList = (this.meetingResponse && Array.isArray(this.meetingResponse.agendaList)) ? this.meetingResponse.agendaList : [];
        for (const ag of agList) {
          if (ag && Array.isArray(ag.minutesList)) {
            const min = ag.minutesList.find((m: any) => (m && (m.decisionId === decisionIdVal)));
            if (min) {
              try {
                if ('decisionDescription' in min) min.decisionDescription = html || '';
                else min.noteDescription = html || '';
              } catch {}
              break;
            }
          }
        }
      } catch {}
      const legacy = document.createElement('div');
      legacy.id = 'agMinId' + decisionIdVal;
      legacy.classList.add('agChildDecision','minComCls');
      legacy.setAttribute('minId', String(decisionIdVal));
      legacy.setAttribute('minid', String(decisionIdVal));
      legacy.setAttribute('decisionId', String(decisionIdVal));
      legacy.setAttribute('agId', String(this.minAttrList.agendaId));
      legacy.setAttribute('agid', String(this.minAttrList.agendaId));
      legacy.setAttribute('parentAgId', String(this.minAttrList.agendaId));
      legacy.setAttribute('entityType', this.minAttrList?.entityType || 'MD');
      legacy.innerHTML = html || '';
      const fakeEvent: any = { target: legacy, currentTarget: legacy, preventDefault: () => {}, stopPropagation: () => {} };
      this.commonMinService.triggerSaveMinutes(legacy, fakeEvent);
    } catch {}
  }
  @Input() minAttrList:any;

  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd! : boolean;

  @Input()
  deviceLg! : boolean;

  @Input()
  deviceXl! : boolean;
  meetingTourValues = meetingTourValues
  scheduleMeetingTourValues = scheduleMeetingTourValues
  @ViewChild('decisionElement') decisionElement!: ElementRef;

  // CKEditor 5 wiring (mirror of note component)
  public Editor: any = CK5_EDITOR;
  private activeEditor: any;
  private toolbarInteracting = false;
  public ck5Config: any = {};
  public ck5ReadOnlyConfig: any = CK5_READONLY_CONFIG;
  // Quill config for ADC editor
  public editorConfig: any = {
    enableTable : true,
    letter : false,
    modules: {
      toolbar: {
        container: [
          ['bold','italic','underline','strike'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ indent: '+1' }, { indent: '-1' }],
          [{ color: [] }, { background: [] }],
          ['image','link']
        ],
        handlers: {
          insertheaderorfooter: () => {},
          subreport: () => {},
          preview: () => {},
          print: () => {},
          formula: () => {},
        },
      },
    },
    sharedToolbar: { enabled: true, selectorId: 'quill-shared-toolbar' },
    placeholder: ' ',
    theme: 'snow',
  };

  ngOnInit(): void {
    this.commonMinService.setActivateCkEditor(true);
    var padLockValue = this.minAttrList.isPrivate;
    if(padLockValue == 'Y'){
      this.padlock = true;
    }else{
      this.padlock = false;
    }
    // Build common CK5 config with mentions
    try { this.ck5Config = buildCk5Config(this.meetingResponse); }
    catch { this.ck5Config = { toolbar: CK5_TOOLBAR, table: { contentToolbar: ['tableColumn','tableRow','mergeTableCells'] } }; }
  }

  // Move the CKEditor toolbar to the shared container (same UX as notes)
  private moveToolbarToShared(editor: any) {
    try {
      const toolbarEl = editor.ui.view.toolbar.element;
      const shared = document.querySelector('#ckEditBar');
      if (shared && toolbarEl && toolbarEl.parentElement !== shared) {
        (shared as HTMLElement).innerHTML = '';
        (shared as HTMLElement).appendChild(toolbarEl);
        // Ensure the toolbar container is visible
        (shared as HTMLElement).style.display = 'block';
      }
    } catch {}
  }

  // Wire the image upload adapter using common config
  private setupCk5UploadAdapter(editor: any) {
    try {
      const cfg = this.agoraConfig.getConfig();
      setupCommonCk5UploadAdapter(
        editor,
        cfg.apiBaseUrl,
        cfg.endpoints.attachment,
        this.freeFormAgenda.meetingResponse?.meetingId,
        this.minAttrList.agendaId
      );
    } catch {}
  }

  handleMouseUp(noteElement: HTMLDivElement): void {
    const selection = window.getSelection();
    if (selection && selection.toString()) {
      noteElement.setAttribute('highlightIndex', '0');
    }
  }
handleFocus(event: FocusEvent, noteElement: HTMLDivElement): void {
  this.sideNavService.closeAllAccordtion();
  this.sideNavService.smootherScroll(event.target);
  noteElement.setAttribute('highlightIndex', '0'); 
}

handleKeyDown(event: KeyboardEvent, noteElement: HTMLDivElement): void {
  // Skip Alt+N/D/T/1/2/3/G shortcuts - they're handled separately in the keydown listener
  const isAltShortcut = event.altKey && (
    event.keyCode === 78 || // N
    event.keyCode === 68 || // D
    event.keyCode === 84 || // T
    event.keyCode === 49 || event.keyCode === 97 || // 1
    event.keyCode === 50 || event.keyCode === 98 || // 2
    event.keyCode === 51 || event.keyCode === 99 || // 3
    event.keyCode === 71    // G
  );
  if (!isAltShortcut) {
    this.freeFormAgenda.trackChangesWhileEditing(
      noteElement.getAttribute('decisionId')!,
      noteElement.getAttribute('agId')!,
      event,
      noteElement.getAttribute('entityType')!,
      'agMinId' + noteElement.getAttribute('decisionId')
    );
  }
  if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'h') {
    event.preventDefault();
    this.highlightNextText(noteElement);
  }
}

highlightNextText(noteElement: HTMLDivElement): void {
  // const regex = /\[XXXXXX\]/gi;
  const regex = environment_const.patternKey;
  const content = noteElement.textContent || '';
  const matches = Array.from(content.matchAll(regex));
  const count = matches.length;
  if (count === 0) return;

  let currentIndex = parseInt(noteElement.getAttribute('highlightIndex') || '0', 10);
  noteElement.setAttribute('highlightIndex', ((currentIndex + 1) % count).toString());

  this.applyHighlight(noteElement, matches, currentIndex);
}

applyHighlight(noteElement: HTMLDivElement, matches: RegExpMatchArray[], highlightIndex: number): void {
  if (!noteElement.firstChild) return;

  const selection = window.getSelection();
  const range = document.createRange();
  
  const match = matches[highlightIndex];
  if (!match) return;
  const start = match.index!;
  const end = start + match[0].length;


  let offset = 0;
  let found = false;
  const nodes = Array.from(noteElement.childNodes);
  for (const node of nodes) {
    const nodeLength = node.textContent?.length || 0;

    if (offset + nodeLength >= start && !found) {
      const relativeStart = start - offset;
      const relativeEnd = end - offset;
      
      range.setStart(node, relativeStart);
      range.setEnd(node, Math.min(relativeEnd, nodeLength));

      found = true;
      break;
    }

    offset += nodeLength;
  }

  if (found) {
    selection?.removeAllRanges();
    selection?.addRange(range);
  }
}
  ngAfterViewInit() {
    this.commonMinService.activateAllCkeditor('agChildDecision');
    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.NOTES,this.utility.permissionType.MODIFY);
    
    
    if(!roleFlag){
      this.disableDecisionIcon = true;
      // $("#insertAttendeeSec").attr('contenteditable', false);
      this.selectedTabName = roleFlag;
    }else{
      this.disableDecisionIcon = false;
    }
    if(this.contentEditableBoolmin == false){
      for(var i = 0; i < document.getElementsByClassName('agChildDecision').length; i++){
        document.getElementsByClassName('agChildDecision')[i].setAttribute('contenteditable','false')
      }
     }
     
       //code added to allow to make private only for created user
    if(this.minAttrList.createdBy==localStorage.getItem("userId")){
      this.padlockDisable=false;
    }else{
      this.padlockDisable=true;
    }
    //close
  }

  getMinComStatusCode(){

    if(this.meetingResponse.commonMomStatusCode == 'A'){
      this.disaleAttachmentFileIcon = true;
    }else{
      this.disaleAttachmentFileIcon = false;
    }
  }

  
  ngOnDestroy(){
    // for (var instance in CKEDITOR.instances) {
    //   CKEDITOR.instances[instance].destroy();
    // }
  }

  //attachment dialog

  openConfidentialDialog(e : any, m : any) {
     let attchDialog =  this.dialog.open(AttachmentDialogComponent,{
      data:{e,m,"data" : this.contentEditableBoolmin,"disaleAttachmentFileIcon":this.disaleAttachmentFileIcon},
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                  maxWidth : "100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        attchDialog.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        attchDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('100vw', '100vh');
      } 
    });
    attchDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      this.meetingService.fetchDecision(e._id).subscribe((data: any) => {
        
        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
           this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
           this.freeFormAgenda.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt,'MD');
          }
         }
      });

    })
    //
  }

  //agenda link dialog

  addNewLink(entityId:any, meetingId:any) {
    let addLinkDialog = this.dialog.open(AddLinkDialogComponent, {
      data:{entityId,meetingId,"entityType":"MD","attachmentMode":"LI","data" : this.contentEditableBoolmin,"disaleAttachmentFileIcon":this.disaleAttachmentFileIcon},
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                  maxWidth : '100%',
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        addLinkDialog.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        addLinkDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        addLinkDialog.updateSize('100vw', '100vh');
      } 
    });
    addLinkDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      this.meetingService.fetchDecision(entityId).subscribe((data: any) => {
        
        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
           this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
           this.freeFormAgenda.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt,'MD');
          }
         }
      });

    })
  }

  trackChanges(id : any){
    this.showToolTip = true;
    //
    let elementCreation = document.getElementById('agMinId'+id);
    $('#agMinId'+id).css("border","5px solid rgba(0,0,0,.12)")
  }

  removeTrackChanges(id : any){
    $('#agMinId'+id).css("border","0px")
    this.showToolTip = false
  }

  statusTracker(id : any, vari : any){
    if(vari == 'active'){
      let element = (<HTMLElement>document.getElementById("agMinId"+id))
      element.contentEditable = 'false'
    }
    else if(vari == 'inActive'){
      let element = (<HTMLElement>document.getElementById("agMinId"+id))
      element.contentEditable = 'true'
    }
  }

  //padlock function
  togglePadLock(e:any) {
    // if((e.target.textContent).trim() == "lock_open"){
    //   this.isPrivate = "Y";
    //  }
    //  else{
    //    this.isPrivate = "N";
    //  }
    this.padlock = !this.padlock;
      this.isPrivate = this.padlock ? 'Y' : 'N';

    var data={}
    var decisionJson={
    "isPrivate":  this.isPrivate,
    "agendaId": this.minAttrList.agendaId,
    "meetingId": this.minAttrList.meetingId,
    "entityType": this.minAttrList.entityType,
    "minutesId": this.minAttrList.decisionId,
    "noteTypeCode": this.minAttrList.noteTypeCode,
    "decisionId": this.minAttrList.decisionId
    }
   var saveUrl = this.freeFormAgenda.getSaveUrl ("Y",this.minAttrList.entityType,decisionJson);
   this.freeFormAgenda.saveMinutesAttributes(data, decisionJson, saveUrl, "Y") .then((result: any) => {
                Object.assign(this.minAttrList, result);

    if(this.isPrivate == 'Y'){
       this.editCollabData.elementId= this.minAttrList.decisionId;
       this.editCollabData.agElementId=this.minAttrList.agendaId;
       this.editCollabData.meetingId=this.minAttrList.meetingId;
       this.editCollabData.collabType='MINPRIVATE'
   }else{
     this.meetingResponse.agendaList.forEach((agElem: any, agIndex: any) => {
       
       if (agElem.agendaId == this.minAttrList.agendaId) {
         
         this.editCollabData.agElemPosition=agIndex;
         
          if (agElem.minutesList != null && agElem.minutesList != undefined) {
           agElem.minutesList.forEach((minElem: any, minIndex: any) => {
             
             if ((minElem.decisionId != null && minElem.decisionId == this.minAttrList.decisionId)) {
               
             this.editCollabData.minElemPosition = minIndex;
             }
           });
         }
       }
     });
     this.editCollabData.elementVal=this.minAttrList;
     this.editCollabData.collabType='MIN';
     this.editCollabData.elementId=this.minAttrList.decisionId;
     this.editCollabData.meetingId=this.minAttrList.meetingId;
    }
    this.freeFormAgenda.callPushMessageToServer(this.editCollabData,'','');

  });
  }

  toggleResPadLock(e:any) {
    // if((e.target.textContent).trim() == "lock_open private" || (e.target.textContent).trim() == "lock_open"){
    //  this.isPrivate = "Y";
    // }
    // else{
    //   this.isPrivate = "N";
    // }
    this.padlock = !this.padlock;
      this.isPrivate = this.padlock ? 'Y' : 'N';

    var data={}
    var decisionJson={
      "isPrivate":  this.isPrivate,
      "agendaId": this.minAttrList.agendaId,
      "meetingId": this.minAttrList.meetingId,
      "entityType": this.minAttrList.entityType,
      "minutesId": this.minAttrList.decisionId,
      "noteTypeCode": this.minAttrList.noteTypeCode,
      "decisionId": this.minAttrList.decisionId
    }
   var saveUrl = this.freeFormAgenda.getSaveUrl ("Y",this.minAttrList.entityType,decisionJson);
   this.freeFormAgenda.saveMinutesAttributes(data, decisionJson, saveUrl, "Y")
  }
  
  getAttachCount(e:any){
     this.meetingService.fetchDecision(e.decisionId).subscribe((data: any) => { 
      this.agendaAttachResp = data.body;
      this.attachCount = false;
   });  
  }

//   ngOnChanges(event : any){
//     

//     let idReference = 'agMinId'+this.minAttrList.decisionId
//     let agMinId = (<HTMLElement>document.getElementById('agMinId'+this.minAttrList.decisionId));

//     // (<HTMLElement>document.getElementById('agMinId'+event.collbElementId.currentValue)).addEventListener('keyup', (e : any) => {
//     
//     
//     // })
    
//     
//     // if(this.minAttrList.rowStatus != undefined || this.minAttrList.rowStatus != null){
//     //   let noteIdAccess = (<HTMLElement>document.getElementById('agMinId'+event.collbElementId.currentValue))
//     //     noteIdAccess.title = this.minAttrList.rowStatus
//     // }
//     // let noteId = document.getElementById(event)
//     
//     
//     
//     
//     function getCaretCoordinates() {
//       let x = 0,
//         y = 0;
//       const isSupported = typeof window.getSelection !== "undefined";
//       if (isSupported) {
//         const selection = window.getSelection();
//         if (selection!.rangeCount !== 0) {
//           const range = selection!.getRangeAt(0).cloneRange();
//           range.collapse(true);
//           const rect = range.getClientRects()[0];
//           if (rect) {
//             x = rect.left;
//             y = rect.top;
//           }
//         }
//       }
//       return { x, y };
//     }
    
//     function toggleTooltip(event: { target: any; }, contenteditable: { contains: (arg0: any) => any; }) {
//       // window.alert("calledddddd")
//       if(event.target.id == idReference){
//         // window.alert("code triggered")
//         const tooltip = document.getElementById("decision-tooltip");

//         if (contenteditable.contains(event.target)) {
//           // window.alert("called")
//           const { x, y } = getCaretCoordinates();

//           tooltip!.setAttribute("aria-hidden", "false");
//           tooltip!.setAttribute(
//             "style",
//             `display: inline-block;
//             position : absolute; 
//             left: ${x - 132}px;
//             top: ${y - 390}px`
//           );
//         } 
//         else {
//           tooltip!.setAttribute("aria-hidden", "true");
//           tooltip!.setAttribute("style", "display: none;");
//         }
//       }


      
//     }

//     window.addEventListener("click", (e) => toggleTooltip(e, agMinId));
//     //window.addEventListener("focus", (e) => toggleTooltip(e, agMinId))
// //window.addEventListener("blur", (e) => toggleTooltip(e, agMinId))
//     window.addEventListener("keyup", (e) => toggleTooltip(e, agMinId));
    
//   }
  
createEmptyAgenda(event:any){
  
  var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.AGENDA,this.utility.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
  var newAg='AG'
  this.freeFormAgenda.trackAgendaEventOnClick(event,newAg);

}

createEmptyNote(event:any){
  
  var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.NOTES,this.utility.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
  var entityType="/nn";
  this.freeFormAgenda.trackAgendaEventOnClick(event,entityType);

}

createEmptyTask(event:any){
  
  var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.TASK,this.utility.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
  var entityType="/tt";
  this.freeFormAgenda.trackAgendaEventOnClick(event,entityType);

}

createEmptyDecision(event:any){
  
  var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.NOTES,this.utility.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
  var entityType="/dd";
  this.freeFormAgenda.trackAgendaEventOnClick(event,entityType);

}

history(entityId:any,modifiedName:any) {

  var entityType ='MD';
  this.historyDialogService.openHistoryDialog(entityId,entityType, modifiedName, this.isMedium, this.isSmall, this.isExtraSmall);
}
blur(target:any,event:any){
  var selectTextAsDecision = (event.altKey  &&  (event.keyCode == 78 || event.keyCode == 68 || event.keyCode == 84));//(ALT+N)
  if(selectTextAsDecision){
  this.commonMinService.triggerSaveMinutes(target,event);
  }
}

}
